import { useCallback } from 'react'
import styled, { CSSObject } from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { FusionColor } from '../../../theme/FusionStyle'

// typescript does not put together enums that use other enums properly
type V2L1BooleanButtonUncheckedColor = (
	FusionColor.Lines|
	FusionColor.OrangeLight2
)
type V2L1BooleanButtonCheckedColor = (
	FusionColor.GoGreen|
	FusionColor.StopRed|
	FusionColor.OrangeMain
)

interface V2L1BooleanButtonRootProps {
	uncheckedColor?: V2L1BooleanButtonUncheckedColor
	checkedColor: V2L1BooleanButtonCheckedColor
	onClick?: React.MouseEventHandler<HTMLButtonElement>
	checked: boolean
}

const V2L1BooleanButtonRoot = styled.button<V2L1BooleanButtonRootProps>(({
	theme,
	uncheckedColor = FusionColor.Lines,
	checkedColor,
	onClick,
	checked,
}) => {
	const style: CSSObject = {
		all: 'unset',
		boxSizing: 'border-box',
		'&:hover': {
			cursor: onClick ? 'pointer' : 'default',
		},
		borderRadius: '50%',
		fontSize: `${14/16}rem`,
		padding: '0.5rem',
	}
	if(checked) {
		return {
			...style,
			border: `1px solid ${theme.colors[checkedColor]}`,
			backgroundColor: theme.colors[checkedColor],
			color: theme.colors.white,
		}
	} else {
		switch(uncheckedColor) {
			case FusionColor.Lines:
				return {
					...style,
					border: `1px solid ${theme.colors.lines}`,
					backgroundColor: theme.colors.white,
					color: theme.colors.inputLabel,
				}
			case FusionColor.OrangeLight2:
				return {
					...style,
					border: `1px solid ${theme.colors.orangeLight1}`,
					backgroundColor: theme.colors.orangeLight2,
					color: theme.colors.bloodOrange,
				}
		}
	}
	// "it's brorked, fix it!!"
	return {
		...style,
		backgroundColor: 'black',
		color: 'black',
	}
})

type V2L1BooleanButtonChangeEvent = {
	target: {
		checked: boolean,
	},
}

interface V2L1BooleanButtonProps {
	icon: IconProp
	uncheckedColor?: V2L1BooleanButtonUncheckedColor
	checkedColor: V2L1BooleanButtonCheckedColor
	checked: boolean
	onChange?: (e: V2L1BooleanButtonChangeEvent) => void,
}

export const V2L1BooleanButton = ({
	icon,
	uncheckedColor, 
	checkedColor,
	checked,
	onChange
}: V2L1BooleanButtonProps) => {
	const handleCheck = useCallback(() => {
		if(onChange) {
			onChange({
				target: {
					checked: !checked,
				}
			})
		}
	}, [onChange, checked])

	return (
		<V2L1BooleanButtonRoot
			uncheckedColor={uncheckedColor}
			checkedColor={checkedColor}
			checked={checked}
			onClick={onChange ? handleCheck : undefined}
		>
			<FontAwesomeIcon fixedWidth icon={icon} />
		</V2L1BooleanButtonRoot>
	)
}
